var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hero)?_c('div',{staticClass:"hero-container"},[_c('img',{staticClass:"hero-banner",attrs:{"src":_vm.hero.image,"alt":_vm.hero.imageAlt}}),_c('video',{staticClass:"hero-video",attrs:{"loop":"","autoplay":"","muted":"","autobuffer":"","preload":"auto","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.hero && _vm.hero.video !== '' && _vm.hero.type === 'video/mp4'
          ? _vm.hero.video
          : '',"type":"video/mp4"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }